import React from "react";
import { TimelineRollupView } from "./TimelineRollup";

export default function TimelineProjected() {
  return <TimelineRollupView mode="projected" />;
}